import { Controller } from 'stimulus';

class ProductSortController extends Controller {
  connect() {
    this.sortBy = 'price:asc';
  }

  onSortChange({ currentTarget }) {
    this.sortBy = currentTarget.value;

    this.sort();
  }

  sort() {
    if (!this.productTargets?.length) return;

    const sortedProducts = this.productTargets
      .sort((a, b) => {
        const {
          sortPrice: aPrice,
          sortCubicMeters: aCubicMeters,
          sortEnergyClass: aEnergyClass,
        } = a.dataset;

        const {
          sortPrice: bPrice,
          sortCubicMeters: bCubicMeters,
          sortEnergyClass: bEnergyClass,
        } = b.dataset;

        switch (this.sortBy) {
          case 'price:desc':
            return bPrice - aPrice;
          case 'cubic_meters:asc':
            return aCubicMeters.split('-')[0] - bCubicMeters.split('-')[0];
          case 'cubic_meters:desc':
            return bCubicMeters.split('-')[0] - aCubicMeters.split('-')[0];
          case 'energy_class:asc':
            return aEnergyClass.localeCompare(bEnergyClass);
          case 'energy_class:desc':
            return bEnergyClass.localeCompare(aEnergyClass);
          default:
            return aPrice - bPrice;
        }
      })
      .map((product) => product.outerHTML)
      .join('');

    this.outputSortedProducts(sortedProducts);
  }

  outputSortedProducts(products) {
    this.outputTarget.innerHTML = products;
  }
}

ProductSortController.targets = [
  'output',
  'product',
];

export default ProductSortController;
